import user from "./user";
import clients from "./clients";
import board from "./board";
import column from "./column";
import ticket from "./ticket";
import calendar from "./calendar";
import search from "./search";
import clientContact from "./clientContact";
import notification from "./notification";
import report from "./report";
import subscription from "./subscription";

const api = {
    user: user,
    clients: clients,
    board: board,
    column: column,
    ticket: ticket,
    calendar: calendar,
    search: search,
    clientContact: clientContact,
    notification: notification,
    report: report,
    subscription: subscription,
};

function handleResponse(res: Response) {
    if (!res.ok) {
        throw Error(res.statusText);
    } else {
        const contentType = res.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            return res.json();
        } else {
            return res;
        }
    }
}

async function handleDownload(res: Response, fileFormat: string) {
    const data = await res.json();

    var binaryString = window.atob(data.Data);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }

    var blob = new Blob([bytes], { type: fileFormat });
    var link = document.createElement("a");
    link.setAttribute("target", "_blank");
    link.href = window.URL.createObjectURL(blob);
    link.download = data.FileName;
    link.click();
}

// export const API_URI = "https://workflow-api.amasocial.co.za";
export const MainDomain = window.location.hostname.split(".")[1]; // workflow-api.brandfootprints.co.za <---- window.location.hostname
export const API_URI = `https://workflow-api.${MainDomain}.co.za`;

//export const MainDomain = "amasocial";
//export const API_URI = "https://localhost:44343";

export async function apiGet(url: string) {
    return fetch(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.AccessToken}`,
            "Content-Type": "application/json",
        },
    }).then((res) => handleResponse(res));
}

export async function apiPostAnon(url: string, body?: object) {
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
        },
    }).then((res) => handleResponse(res));
}

export async function apiPost(url: string, body?: object) {
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            Authorization: `Bearer ${localStorage.AccessToken}`,
            "Content-Type": "application/json",
        },
    }).then((res) => handleResponse(res));
}

export async function apiPut(url: string, body?: object) {
    return fetch(url, {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
            Authorization: `Bearer ${localStorage.AccessToken}`,
            "Content-Type": "application/json",
        },
    }).then((res) => handleResponse(res));
}

export async function apiDelete(url: string, body?: object) {
    return fetch(url, {
        method: "DELETE",
        body: JSON.stringify(body),
        headers: {
            Authorization: `Bearer ${localStorage.AccessToken}`,
            "Content-Type": "application/json",
        },
    }).then((res) => handleResponse(res));
}

export async function apiDownload(url: string, fileFormat: string, body?: object) {
    return await fetch(url, {
        method: "GET",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.AccessToken}`,
        },
    }).then(async (res) => await handleDownload(res, fileFormat));
}

export default api;
